import {
    REQUEST_ACCOUNT_PURCHASES,
    RECEIVE_ACCOUNT_PURCHASES,
    FAILURE_ACCOUNT_PURCHASES
} from './constants';
import { CALL_API } from '../../../middlewares/api';
import _ from 'lodash';

// purchases
export function fetchAccountPurchasesIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/purchase',
            types: [
                REQUEST_ACCOUNT_PURCHASES,
                RECEIVE_ACCOUNT_PURCHASES,
                FAILURE_ACCOUNT_PURCHASES
            ],
            shouldCallAPI: state => shouldFetchAccountPurchase(state),
            authenticated: true
        }
    };
}

const shouldFetchAccountPurchase = state => {
    const purchases = state.account.purchases;
    const fetching = state.account.fetching;

    if (fetching) {
        return false;
    } else if (_.isEmpty(purchases)) {
        return true;
    } else {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/services/account/cashback/actions.js